// BugCard.js
import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const BugCard = ({ program }) => {
  return (
    <Link to={`/bounty-details/${program.bounty_id}`} className="col-md-3">
      <div className="card mt-4">
        <div className="card-body shadow-sm">
          <h6 className="text-danger">Bug Bounty</h6>
          <div className='d-flex justify-content-around border-bottom border-1 pb-2 mb-2'>
            <img src={program.image} alt="Logo" className="img-fluid mb-2" style={{ height: "60px" }} />
          </div>
          <h5 className="card-title text-primary">{program.bounty_title}</h5>
          <p className="card-text">{program.bounty_description}</p>
          <p className="text mt-2">${program.p1} - ${program.payout}</p>
        </div>
      </div>
    </Link>
  );
};

export default BugCard;
